import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, ShoppingBag, User, Grid } from 'lucide-react';
import { useCart } from '../../context/CartContext';

export const MobileNav = () => {
    const location = useLocation();
    const { itemCount } = useCart();

    const tabs = [
        { icon: Home, label: 'Home', path: '/' },
        { icon: Grid, label: 'Shop', path: '/products' },
        { icon: Search, label: 'Search', path: '/products' },
        { icon: ShoppingBag, label: 'Cart', path: '/cart' },
        { icon: User, label: 'Account', path: '/login' },
    ];

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-black border-t border-border">
            <div className="flex items-center justify-around py-2">
                {tabs.map(({ icon: Icon, label, path }) => {
                    const isActive = location.pathname === path;
                    return (
                        <Link key={label} to={path}
                            className={`flex flex-col items-center gap-1 px-3 py-1 transition-colors ${isActive ? 'text-lime' : 'text-muted-foreground'}`}>
                            <div className="relative">
                                <Icon className="w-5 h-5" />
                                {label === 'Cart' && itemCount > 0 && (
                                    <span className="absolute -top-2 -right-2 bg-lime text-black text-[9px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
                                        {itemCount}
                                    </span>
                                )}
                            </div>
                            <span className="text-[10px] font-medium tracking-wide uppercase">{label}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
};
